import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useHttp } from '../hooks/http.hook'
import { AuthContext } from '../context/AuthContext'
import { LanguagesContext } from "../context/LanguagesContext";
import { Loader } from './components/Loader'
import { Toaster } from './components/Toaster'
import { Link } from 'react-router-dom'
//import { Row } from 'react-bootstrap'; // { Button, Form, Row, Col, Table } 
//import { FaTrashAlt, FaSave, FaExternalLinkAlt } from 'react-icons/fa';
import { NewFormBlock } from './components/NewFormBlock';

import './css/ContentPages.css';

export const ClientsPage = () => {
    const { token } = useContext(AuthContext)
    const { getCurrentLanguage, getCurrentNameCode } = useContext(LanguagesContext)
    const [clients, setClients] = useState([])
    const { request, loading, error } = useHttp()
    const [receivedError, setReceivedError] = useState(error)

    const [clientUpdateForm, setClientUpdateForm] = useState([])

    /*  const updateClientHandler = (data, key, val) => {
          const temp = clientUpdateForm
          if (temp.some(item => item.id === data.id)) {
              //console.log("Object found inside the array.");
              setClientUpdateForm(
                  clientUpdateForm => clientUpdateForm.map(
                      item => {
  
                          if (item.id === data.id) {
                              item[key] = val
                          }
                          return item
                      }
                  )
              )
          } else {
              //console.log("Object not found.");
              setClientUpdateForm([...clientUpdateForm, data])
          }
      }*/ // used for update client name on this page

    const fetchClients = useCallback(async () => {
        try {
            const fetched = await request('/client/all', 'GET', null, {
                'x-access-token': token
            })
            if (fetched) {
                console.log(fetched);
                setClients(fetched)
            }
        } catch (e) {
            setReceivedError(e)
        }
    }, [token, request])

    useEffect(() => {
        fetchClients()
    }, [fetchClients])

    const deleteClient = async (clientId) => {

        try {
            const data = await request(`/client/${clientId}/remove`, 'POST', null, {
                'x-access-token': token
            })

            if (data.changed === 1) {
                setClients(clients => clients.filter(item => item.id !== clientId))
            }

            // setClients(clients => [...clients, test_client] )

            // history.push(`/detail/${data.link._id}`)
        } catch (e) {
            setReceivedError(e)
        }


    }

    const changeClientName = async (client_id) => {
        let data_form = clientUpdateForm.filter(item => {
            return item.id === client_id
        })
        try {
            const data = await request(`/client/${client_id}/update/name`, 'POST', data_form[0], {
                'x-access-token': token
            })

            if (data.changed === 1) {
                //if request success change name
                // console.log('name should be changed');

                setClients(
                    clients => clients.map(
                        item => {
                            if (item.id === client_id)
                                item.name = data_form[0].name
                            return item;
                        }
                    )
                )
            }
            setClientUpdateForm(client => client.filter(item => item.id !== client_id))
        } catch (e) {
            setReceivedError(e)
        }
    }


    const addClient = async (nameForm) => {
        try {
            const data = await request('/client/add', 'POST', { name: nameForm[getCurrentNameCode()] }, {
                'x-access-token': token
            })

            if (data.client) {
                setClients(clients => [...clients, data.client[0]])
            }

        } catch (e) {
            setReceivedError(e)
        }
    }

    return (
        <>
            {(receivedError) ? <Toaster errors_list={receivedError} error_state={setReceivedError} /> : ''}
            {loading && <Loader />}

            <h3 className="FormTitle">Clients</h3>

            <NewFormBlock languageData={getCurrentLanguage()} addAction={addClient} loadingState={loading} buttonLabel={'Add Client'} placeholderText={"Enter new client name"} />

            <table className="Table">
                <thead>
                    <tr className="TableBlock">
                        <th className="TableFirstLineBlock">#</th>
                        <th className="TableFirstLineBlock">Name</th>
                        <th className="TableFirstLineBlock">Details</th>
                        <th className="TableFirstLineBlock">Action</th>
                    </tr>
                </thead>

                <tbody>
                    {(clients && clients.length)
                        ? clients.map((client, index) =>
                            <tr key={client.id}>
                                <td className="TableSecondLineBlock TableSecondLineText CenterContent">
                                    <div className="CenterContent">
                                        {index + 1}
                                    </div>
                                </td>
                                <td className="TableSecondLineBlock TableSecondLineText">
                                    {client.name}
                                </td>
                                <td className="TableSecondLineBlock CenterContent ">
                                    <Link to={`/client/${client.id}`} className=" ml-2">
                                        <img src="/img/Edit.png" alt="" className="TableSecondLineImg mx-2" />
                                    </Link>
                                </td>
                                <td className="TableSecondLineBlock  ">
                                    <div className="CenterContent">
                                        {clientUpdateForm.some(clientUpdateForm => clientUpdateForm.id === client.id && clientUpdateForm.updated === 1)
                                            && <img src="/img/save_white.png" alt="" onClick={() => changeClientName(client.id, client.name)}
                                                className="TableSecondLineImg mx-3" />}

                                        <img
                                            src="/img/TrashB.png" alt="" onClick={() => {
                                                if (window.confirm('Delete this item?')) {
                                                    deleteClient(client.id)
                                                }
                                            }}
                                            className="TableSecondLineImg mx-2" />
                                    </div>
                                </td>
                            </tr>
                        )
                        : <tr>
                            <td> </td>
                            <td>No clients</td>
                            <td> </td>
                            <td> </td>
                        </tr>}
                </tbody>
            </table>


        </>
    )
}
